export const enDic = {
    attributes: {
        component_id: 'component',
        customer_id: 'customer',
        component_type_id: 'type',
        packet_number: 'packet',
        interval_control: 'control',
        in_date: 'date IN',
        out_date: 'date IN',
        control_date: 'control date',
        packet_id: 'packet',
        weight_rate: 'weight',
        max_weight_rate: 'max. weight',
        min_weight_rate: 'min. weight',
        back_pressure_rate: 'back pressure',
        min_back_pressure_rate: 'min. back pressure',
        max_back_pressure_rate: 'max. back pressure',
        leakage_rate: 'leakage',
        min_leakage_rate: 'min. leakage',
        max_leakage_rate: 'max. leakage'
    }
}
